if (!customElements.get('ls-mobile-atc')) {
  customElements.define(
    'ls-mobile-atc',
    class extends HTMLElement {
      connectedCallback() {
        this.variantInput = this.querySelector('input[name="id"]');
        this.quantityInput = this.querySelector('input[name="quantity"]');
        this.button = this.querySelector('button[name="add"]');
        this.price = this.querySelector('.price');
        if (!this.variantInput || !this.button) return;

        this.observer = new MutationObserver(() => this.scheduleSync());
        this.bindMainProduct();
        document.addEventListener('input', this.handleChange);
        document.addEventListener('change', this.handleChange);
        document.addEventListener('product-info:loaded', this.handleProductLoaded);
        this.addEventListener('submit', this.handleSubmit, true);
        this.resizeObserver = new ResizeObserver(() => this.updateHeight());
        this.resizeObserver.observe(this);
        this.updateHeight();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.syncFrame);
        document.removeEventListener('input', this.handleChange);
        document.removeEventListener('change', this.handleChange);
        document.removeEventListener('product-info:loaded', this.handleProductLoaded);
        this.removeEventListener('submit', this.handleSubmit, true);
        document.documentElement.style.removeProperty('--ls-mobile-atc-height');
      }

      handleChange = (event) => {
        if (this.mainProduct?.contains(event.target)) this.scheduleSync();
      };

      handleProductLoaded = () => queueMicrotask(() => {
        if (this.isConnected) this.bindMainProduct();
      });

      bindMainProduct() {
        this.observer.disconnect();
        this.mainProduct = document.querySelector('product-info[id^="MainProduct-"]');
        if (this.mainProduct) {
          this.observer.observe(this.mainProduct, {
            subtree: true,
            childList: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['value', 'disabled', 'aria-disabled', 'class', 'hidden'],
          });
        }
        this.syncState();
      }

      scheduleSync() {
        if (this.syncFrame) return;
        this.syncFrame = requestAnimationFrame(() => {
          this.syncFrame = null;
          if (this.isConnected) this.syncState();
        });
      }

      syncState() {
        this.mainForm = this.mainProduct?.querySelector('form[data-type="add-to-cart-form"]');
        this.mainButton = this.mainForm?.querySelector('button[name="add"]');
        if (!this.mainForm || !this.mainButton) {
          this.button.disabled = true;
          return;
        }

        this.variantInput.value = this.mainForm.elements.namedItem('id')?.value || '';
        const quantity = this.mainForm.elements.namedItem('quantity');
        if (this.quantityInput) this.quantityInput.value = quantity ? quantity.value : '1';

        const blocked = !this.variantInput.value || this.mainButton.disabled ||
          this.mainButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = blocked;
        this.button.setAttribute('aria-disabled', String(blocked));
        const loading = this.mainButton.classList.contains('loading');
        this.button.classList.toggle('loading', loading);
        this.querySelector('.loading__spinner')?.classList.toggle('hidden', !loading);
        const label = this.mainButton.querySelector('span')?.textContent;
        const buttonLabel = this.button.querySelector('span');
        if (buttonLabel && label !== undefined && buttonLabel.textContent !== label) {
          buttonLabel.textContent = label;
        }

        const priceWrapper = this.mainProduct.querySelector('[id^="price-"]');
        const sourcePrice = priceWrapper?.querySelector('.price');
        if (sourcePrice && this.price) {
          const signature = sourcePrice.outerHTML;
          if (signature !== this.priceSignature) {
            const copy = sourcePrice.cloneNode(true);
            copy.querySelectorAll('.badge').forEach((badge) => badge.remove());
            copy.classList.remove('price--large', 'price--show-badge');
            this.price.className = `${copy.className} ls-mobile-atc__price`;
            this.price.innerHTML = copy.innerHTML;
            this.priceSignature = signature;
          }
          this.price.classList.toggle('hidden', priceWrapper.classList.contains('hidden'));
        }

        const sourceError = this.mainForm.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
        const error = this.querySelector('.product-form__error-message-wrapper');
        if (sourceError && error) {
          error.hidden = sourceError.hidden;
          const message = sourceError.querySelector('.product-form__error-message')?.textContent || '';
          const target = error.querySelector('.product-form__error-message');
          if (target && target.textContent !== message) target.textContent = message;
        }
      }

      handleSubmit = (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        this.syncState();
        if (!this.mainForm || this.button.disabled) return;
        this.mainForm.requestSubmit(this.mainButton);
        this.syncState();
      };

      updateHeight() {
        const height = Math.ceil(this.getBoundingClientRect().height);
        const root = document.documentElement.style;
        if (height && root.getPropertyValue('--ls-mobile-atc-height') !== `${height}px`) {
          root.setProperty('--ls-mobile-atc-height', `${height}px`);
        }
      }
    },
  );
}

